import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Box, Pagination } from '@mui/material';

const ROWS_PER_PAGE = 20;

export default function QuestionList({ setEditingQuestion, setTab }) {
  const [questions, setQuestions] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchQuestions = async () => {
      const from = (page - 1) * ROWS_PER_PAGE;
      const to = from + ROWS_PER_PAGE - 1;

      // 전체 개수 가져오기
      const { count: totalCount, error: countError } = await supabase
        .from('mbe_questions_readable')
        .select('*', { count: 'exact', head: true });
      
      if (countError) {
        console.error('Error counting questions:', countError);
      } else {
        setCount(totalCount || 0);
      }

      // 현재 페이지 데이터 가져오기
      const { data, error: dataError } = await supabase
        .from('mbe_questions_readable')
        .select('*')
        .order('id', { ascending: false })
        .range(from, to);

      if (dataError) {
        console.error('Error fetching questions:', dataError);
        setQuestions([]);
      } else {
        setQuestions(data || []);
      }
    };
    fetchQuestions();
  }, [page]); // 페이지가 변경될 때마다 데이터를 다시 불러옵니다.

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>과목</TableCell>
            <TableCell>문제</TableCell>
            <TableCell>수정</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {questions.map(q => (
            <TableRow key={q.id}>
              <TableCell>{q.id}</TableCell>
              <TableCell>{q.subject_name}</TableCell>
              <TableCell>{q.question_text.slice(0, 30)}...</TableCell>
              <TableCell>
                <Button onClick={() => {
                  setEditingQuestion(q);
                  setTab('form');
                }}>수정</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Pagination
          count={Math.ceil(count / ROWS_PER_PAGE)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
}
